import 'core-js/es6/promise'
import 'core-js/fn/object/assign'
import 'core-js/fn/object/entries'
import 'core-js/fn/array/find'
import 'core-js/es6/array'
import 'core-js/fn/string/includes'
import 'core-js/fn/number/is-finite'
import 'core-js/es6/symbol'

import './index.css'
import './moment-locale'
import './normalize.css'

import App from './App'
import React from 'react'
import ReactDOM from 'react-dom'
import registerServiceWorker from './registerServiceWorker'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { store, persistor } from './store'
import connectionProxy from './api/connectionProxy'

connectionProxy.getStore(store)

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js